export const BNK_STMT_setBankStatementPasswordReducer = {
  BNK_STMT_setBankStatementPassword: (state, action) => {
    state.bankStatementPassword = action.payload;
  },
};
